<template>
  <div>
    <nav_list :index="3"></nav_list>
    <div class="v3_body">
      <navv title="推荐" en="recommend"> </navv>
      <div class="cont">
        <div
          class="y3"
          v-for="(itm, n) in article.data"
          :key="n"
          @click="jump('/noteinfo?id=' + itm.id)"
        >
          <div class="cover">
            <img :src="itm.paths.cover" alt="" />
          </div>
          <div class="info">

              <div class="notice">{{ itm.paths.title }}</div>
            

              <div class="time">{{ to_ymd(itm.created_at) }}</div>
          

          </div>
        </div>

        <div class="pagination-container">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="article.current_page"
            :page-size="article.per_page"
            :total="article.total"
            @current-change="change_page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import nav_list from "../index/nav_list.vue";
export default {
  name: "index",
  data() {
    return {
      article: [],
      first_load: 1,
      article_page: 1,
      tabs: [],
      city_id: 0,
    };
  },
  methods: {
    clc_tab(city_id) {
      if (this.city_id == city_id) {
        this.city_id = 0;
      } else {
        this.city_id = city_id;
      }
      this.article_page = 1;
      this.f5();
    },
    change_page(e) {
      this.article_page = e;
      this.f5();
    },
    f5() {
      // this.article_page += inc
      this.get("/index/article", {
        page: this.article_page,
        n: 15,
        first_load: this.first_load,
        city_id: this.city_id,
      }).then((e) => {
        this.first_load = 1;
        this.article = e.article;
        if (e.tabs) {
          this.tabs = e.tabs;
        }
      });
    },
  },
  mounted() {
    document.title = this.web_tit;
    this.f5();
  },
  components: {
    //注册
    nav_list,
  },
};
</script>


<style scoped>
.act {
  color: #1c5098 !important;
}

.titz {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;

  background: #fff;
  border-radius: 5px;
  text-align: center;
  padding: 10px 20px;
  margin-bottom: 5px;
}

.cont {
  margin: auto;
  overflow: hidden;
  width: 90%;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 10px;
}

.wl2 {
  flex: 0 0 20%;
  padding: 10px;
  text-align: center;
  position: fixed;
  z-index: 2;
  left: 82vw;
  top: 170px;
}

.y3 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.y3:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.info {
  flex: 0 0 70%;
  padding: 0 30px;
  color: #666;
}
.info div {
  padding: 8px 0;
}
.notice {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  font-size: 20px;
  margin-bottom: 10px;
}
.share {
  color: #ff4d4f;
  cursor: pointer;
}

.cover {
  flex: 0 0 25%;
  min-height: 150px;
  overflow: hidden;
}
.cover img {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.cover:hover img {
  transform: scale(1.05);
}

.time, .pv {
  font-size: 14px;
  color: #999;
}

.pagination-container {
  grid-column: 1 / -1;
  text-align: right;
  padding: 10px 0;
}

.el-pagination {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/note/index.vue